import $ from "jquery";
import Splide from "@splidejs/splide";
$(function () {
	let hero_carousel = document.querySelectorAll(".hero-carousel");
	if (hero_carousel.length > 0) {
		for (let i = 0; i < hero_carousel.length; i++) {
			let heroElement = hero_carousel[i];
			let heroDefaultOptions = {
				type: "loop",
				pagination: false,
			};
			let hero = new Splide(heroElement, heroDefaultOptions);
			hero.mount();
		}
	}
});
